import { createMuiTheme } from '@material-ui/core/styles'
import {
  yellow,
  purple,
  cyan,
  blueGrey,
  teal,
  orange,
  indigo,
  green,
  red,
} from '@material-ui/core/colors'

const lightTheme = createMuiTheme({
  palette: {
    primary: {
      main: '#005F80',
    },
    secondary: {
      main: '#FF7070',
    },
    text: {
      main: '#03111d',
      mainLight: '#E5E3E3',
      mainAlternative: blueGrey[900],
      disabled: '#6b7b89',
      white: '#ffffff',
    },
    background: {
      paper: '#ffffff',
      default: '#ffffff',
      darkOverlay: 'rgba(0, 0, 0, 0.8)',
      overlay: 'rgba(56, 65, 84, 0.8)',
      lightOverlay: 'rgba(56, 65, 84, 0.5)',
      extraLightOverlay: 'rgba(56, 65, 84, 0.05)',
    },
    extras: {
      slate: '#092736',
      lightSlate: '#55586a',
      darkSlateGrey: '#31383e',
      lightBlue: 'rgba(108, 180, 238, 0.5)',
      lightPink: 'rgba(238, 108, 115, 0.5)',
      strongTeal: teal[600],
      strongPink: '#e91e63',
      strongPurple: purple[600],
      strongGreen: green[600],
      strongOrange: orange[600],
      green: green[200],
      cyan: cyan[200],
      yellow: yellow[200],
      red: red[200],
      purple: purple[200],
      teal: teal[200],
      blueGrey: blueGrey[200],
      orange: orange[200],
      indigo: indigo[200],
    },
  },
  typography: {
    fontFamily: [
      'Source Sans Pro',
      'Roboto Condensed',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    fontWeightExtraLight: 200,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightSemiBold: 600,
    fontWeightExtraBold: 700,
    fontWeightBlack: 900,
    letterSpacing: '2px',
  },
  transitions: {
    default: 'all 0.3s ease-in-out',
  },
  overrides: {
    MuiToolbar: {
      regular: {
        minHeight: 64,
      },
    },
  },
})

export { lightTheme }
